import React from 'react';
import { MdClose } from 'react-icons/md';

export type ClearSelectButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const ClearSelectButton: React.FC<ClearSelectButtonProps> = ({ onClick, disabled }) => {
  const handleClick = (e: React.SyntheticEvent<HTMLSpanElement>) => {
    if (disabled) return;

    if (e.type === 'keydown') {
      const keyboardEvent = e as React.KeyboardEvent<HTMLSpanElement>;
      if (keyboardEvent.key !== 'Delete') {
        return;
      }
    }

    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  return (
    <span
      role="button"
      aria-label="Clear selection"
      tabIndex={disabled ? -1 : 0}
      className="ml-1 flex items-center justify-center rounded-full p-1 hover:bg-base-40 cursor-pointer"
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      <MdClose size={16} />
    </span>
  );
};

export default ClearSelectButton;
